import { Component, effect, inject } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { RouterModule, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { PopoverModule } from 'primeng/popover';
import { ToastModule } from 'primeng/toast';
import { LayoutService } from '../service/layout.service';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [RouterModule, CommonModule, StyleClassModule, PopoverModule, ToastModule],
  providers: [MessageService],
  templateUrl: './app.topbar.html',
})
export class AppTopbar {
  items!: MenuItem[];
  readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly messageService = inject(MessageService);
  private _warnToastShown = false;

  constructor(public layoutService: LayoutService) {
    effect(() => {
      const warning = this.authService.sessionWarning();
      if (warning === 'warn' && !this._warnToastShown) {
        this._warnToastShown = true;
        this.messageService.add({
          severity: 'warn',
          summary: '⏰ Heads up!',
          detail: 'Your session bails on you in 30 minutes — wrap up and save before it ghosts you 👻',
          life: 10000,
        });
      }
      if (warning === 'none') {
        this._warnToastShown = false;
      }
    });
  }

  toggleDarkMode() {
    this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
  }

  onLogout() {
    this.authService.logout().subscribe({
      next: () => {},
      error: (error) => {
        console.error('Logout error:', error);
        this.authService.clearAuthState();
        this.router.navigate(['/auth/login']);
      },
    });
  }
}
